module.exports = __webpack_public_path__ + "static/media/sandTime.d5c04fbd.png";